import { sessionGet, SessionKeys } from 'utils/tokenStorage';
import { iframePostMessage } from 'utils/constants';
import { isJsonString, getDefaultHeaders } from './utils';
import ApiError from './apiError';

const request = async (
  url: string,
  options: { [key: string]: any } = {},
  isRequiredProgram: boolean = true,
  isMarkdown: boolean = false,
): Promise<any> => {
  const requestOptions: any = {
    headers: getDefaultHeaders(),
    ...options,
  };
  let response;
  if (!isRequiredProgram) delete requestOptions.headers.Program;

  try {
    response = await fetch(url, requestOptions);
  } catch (e) {
    throw new ApiError({
      message: `Remote API server did not respond: ${url}`,
    });
  }

  const responseText = await response.text();

  switch (response.status) {
    case 200:
    case 201:
    case 204: {
      if (isMarkdown) return responseText;
      return isJsonString(responseText) ? JSON.parse(responseText) : {};
    }
    case 401: {
      window.parent.postMessage(
        {
          payload: {
            action: iframePostMessage.EXPIRED_TOKEN,
          },
        },
        sessionGet(SessionKeys.ORIGIN)!,
      );
      throw new ApiError({
        status: response.status,
        statusText: response.statusText,
      });
    }
    default: {
      const error = isJsonString(responseText)
        ? JSON.parse(responseText)
        : { errors: [], message: 'Server error' };
      throw new ApiError({
        status: response.status,
        statusText: response.statusText,
        message: error.message,
        errors: error.errors,
        details: error.details,
      });
    }
  }
};

//! ====> Consider for DEPRECATION <====
// TODO (MW)[WB-37xx] Remove after apiclient installed

const authRequest = (
  url: string,
  options: { [key: string]: any } = {},
  isRequiredProgram: boolean = true,
): Promise<any> => {
  const token = sessionGet(SessionKeys.AUTH_TOKEN);
  if (token === null || token === '') {
    throw new Error('Undefined Token');
  }

  const jwtToken = `JWT ${token}`;
  const headers = {
    ...getDefaultHeaders(),
    Authorization: jwtToken,
    ...options.headers,
  };

  const userContext = sessionGet(SessionKeys.USER_CONTEXT);
  if (userContext) {
    headers.user_context = userContext;
  }

  const authenticatedRequestOptions = {
    ...options,
    headers,
  };
  return request(url, authenticatedRequestOptions, isRequiredProgram);
};

const baseApi = { request, authRequest };

export default baseApi;
